/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Styles
import styled, { css } from 'styled-components';
import { Flex, Box } from 'UIKit/Grid';
import mq from 'UIKit/Mq';
import Panel from 'sama_global/components/Panel';

// Components
import Header from '@/components/Header';
import Sidebar from '@/components/Sidebar';
import Container from '@/components/Layout/Container';

// StyledComponents
const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;
const WrapperPublic = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
`;
const SidebarCloser = styled.div`
  position: fixed;
  display: none;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s;
  transform: translateX(0);
  ${mq.tabletHorizontal`
    display: block;
    `};
  ${({ navCollapsed }) =>
    navCollapsed &&
    css`
      opacity: 0;
      transform: translateX(-100%);
    `};
`;

/**
 * PrimaryLayout
 * @param {bullean} open open.
 */
export default class PrimaryLayout extends Component {
  /**
   * Class constructor.
   * @param {object} props props.
   */
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.screen.width,
      navCollapsed: window.screen.width <= 1199,
    };
  }

  /**
   * Update component
   */
  componentWillMount() {
    this.updateDimensions();
  }

  /**
   * Update component
   */
  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  /**
   * Update component
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  onSetSidebarOpen = open => {
    this.setState({ navCollapsed: open });
  };

  updateDimensions = () => {
    this.setState({
      windowWidth: window.screen.width,
      navCollapsed: window.screen.width <= 1199,
    });
  };

  /**
   * Render
   * @returns {object}.
   */
  render() {
    const { windowWidth, navCollapsed } = this.state;
    const { children } = this.props;
    return (
      <Wrapper>
        <Flex flexWrap="nowrap" height="100%">
          <SidebarCloser
            navCollapsed={navCollapsed}
            onClick={this.onSetSidebarOpen}
          />
          <Sidebar navCollapsed={navCollapsed} />
          <Box w={1}>
            <Header
              onSetSidebarOpen={this.onSetSidebarOpen}
              navCollapsed={navCollapsed}
              windowWidth={windowWidth}
            />
            <Flex
              px={10}
              py={4}
              overflow="auto"
              position="relative"
              height="calc(100% - 64px)"
              flexDirection="column"
            >
              <Container left>{children}</Container>
            </Flex>
          </Box>
        </Flex>
      </Wrapper>
    );
  }
}

PrimaryLayout.propTypes = {
  children: PropTypes.object.isRequired,
};

/**
 * PublicLayout
 * @returns {object}.
 */
export const PublicLayout = ({ children }) => (
  <WrapperPublic>
    <Box w={['100%', '400px', '450px']} m="auto">
      <Panel>
        <Flex>
          <Box w="100%" position="relative" maxWidth="350px" mx="auto">
            {children}
          </Box>
        </Flex>
      </Panel>
    </Box>
  </WrapperPublic>
);

PublicLayout.propTypes = {
  children: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export const IndexLayout = ({ children }) => <>{children}</>;

IndexLayout.propTypes = {
  children: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};
